import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
var EditEventContactComponent = /** @class */ (function () {
    function EditEventContactComponent(_matDialogRef, data, _aviationEventsService) {
        this._matDialogRef = _matDialogRef;
        this._aviationEventsService = _aviationEventsService;
        this.isBusy = false;
        this.aviationEvent = data.aviationEvent;
        this._origin_contactPersonName = this.aviationEvent.contactPersonName;
        this._origin_contactPersonEmail = this.aviationEvent.contactPersonEmail;
        this._origin_contactPersonPhone = this.aviationEvent.contactPersonPhone;
    }
    EditEventContactComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this._matDialogRef.close(null);
        });
        this.formGroup = new FormGroup({
            contactPersonName: new FormControl(this.aviationEvent.contactPersonName, [Validators.required, Validators.maxLength(256)]),
            contactPersonEmail: new FormControl(this.aviationEvent.contactPersonEmail, [Validators.required, Validators.maxLength(256)]),
            contactPersonPhone: new FormControl(this.aviationEvent.contactPersonPhone, [Validators.required, Validators.maxLength(256)])
        });
    };
    EditEventContactComponent.prototype.cancel = function () {
        this.aviationEvent.contactPersonName = this._origin_contactPersonName;
        this.aviationEvent.contactPersonEmail = this._origin_contactPersonEmail;
        this.aviationEvent.contactPersonPhone = this._origin_contactPersonPhone;
        this._matDialogRef.close(null);
    };
    EditEventContactComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.aviationEvent.contactPersonName) {
                            this.aviationEvent.contactPersonName = this.aviationEvent.contactPersonName.trim();
                        }
                        if (this.aviationEvent.contactPersonEmail) {
                            this.aviationEvent.contactPersonEmail = this.aviationEvent.contactPersonEmail.trim();
                        }
                        if (this.aviationEvent.contactPersonPhone) {
                            this.aviationEvent.contactPersonPhone = this.aviationEvent.contactPersonPhone.trim();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.isBusy = true;
                        return [4 /*yield*/, this._aviationEventsService.updateAviationEvent(this.aviationEvent)];
                    case 2:
                        _a.sent();
                        this.isBusy = false;
                        this._matDialogRef.close(true);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.isBusy = false;
                        this._matDialogRef.close(false);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return EditEventContactComponent;
}());
export { EditEventContactComponent };
